export const AUTH_REMAINING_SEC_REFRESH = 5 * 60;
export const AUTH_TOKEN_VALIDITY_CHECK_INTERVAL_MS = 5000;

export const AUTH_REDIRECT_ROUTE_PATH = "callback";
export const AUTH_REDIRECT_ROUTE_PATH_RETURN_PARAM = "returnTo";
